// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Enel1__layout {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  height: 100vh;
  padding: 0 1em 8em;
  background: var(--color-paper-2);

  z-index: 1000;
  overflow-y: auto;
}

.Enel1__layout article a {
    color: var(--color-blue-1);
    -webkit-text-decoration: underline;
    text-decoration: underline;
    text-underline-offset: 2px;
  }

.Enel1__layout article a:hover {
      opacity: 0.8;
    }

.OPtlA__header {
  display: flex;
  align-items: center;
  gap: 0.8em;
}

.OPtlA__header a {
    font-size: 1.5em;
    color: var(--color-blue-1);
  }

.OPtlA__header h1 {
    margin: 0;
  }
`, "",{"version":3,"sources":["webpack://./src/app/routes/privacy/PrivacyPolicyRoute.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,OAAO;EACP,aAAa;EACb,kBAAkB;EAClB,gCAAgC;;EAEhC,aAAa;EACb,gBAAgB;AAWlB;;AATE;IACE,0BAA0B;IAC1B,kCAA0B;IAA1B,0BAA0B;IAC1B,0BAA0B;EAK5B;;AAHE;MACE,YAAY;IACd;;AAIJ;EACE,aAAa;EACb,mBAAmB;EACnB,UAAU;AAUZ;;AARE;IACE,gBAAgB;IAChB,0BAA0B;EAC5B;;AAEA;IACE,SAAS;EACX","sourcesContent":[".layout {\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  height: 100vh;\n  padding: 0 1em 8em;\n  background: var(--color-paper-2);\n\n  z-index: 1000;\n  overflow-y: auto;\n\n  & article a {\n    color: var(--color-blue-1);\n    text-decoration: underline;\n    text-underline-offset: 2px;\n\n    &:hover {\n      opacity: 0.8;\n    }\n  }\n}\n\n.header {\n  display: flex;\n  align-items: center;\n  gap: 0.8em;\n\n  & a {\n    font-size: 1.5em;\n    color: var(--color-blue-1);\n  }\n\n  & h1 {\n    margin: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export var layout = `Enel1__layout`;
export var header = `OPtlA__header`;
export default ___CSS_LOADER_EXPORT___;
